import servise from '@/router/axios'


export const webReportBiddingPriceList = (params) => {
    return servise({
        url:'/webReportBiddingPrice/dsp/list',
        method:'get',
        params
    })
}